import { segmentAnalytics as analytics } from '@hungryroot/segment';
interface Params {
  id: number;
  name: string;
  category: 'pairings' | 'products';
  location: 'card' | 'RDP' | 'PDP';
  state: boolean;
}

export function trackFavorite(params: Params) {
  const { id, name, category, location, state } = params;
  analytics.track('Product Saved', {
    product_id: id,
    pairing_name: name,
    category,
    location,
    state: state === true ? 1 : 0,
    source: 'web',
  });
}
